// extracted by mini-css-extract-plugin
export default {"routerButton":"RouterButton_routerButton__yxitP","ok":"RouterButton_ok__fu8gH","caution":"RouterButton_caution__UG1ME","danger":"RouterButton_danger__335hL"};